module.exports = __webpack_public_path__ + "fonts/CenturyGothic.09f6b2ba.ttf";